import InstaFeed from './InstaFeed';

export default InstaFeed;
